import * as React from 'react';
import styled from 'styled-components';

export const Sidebar: React.FC = ({ children }) => {
  return <StyledSidebar>{children}</StyledSidebar>;
};

const StyledSidebar = styled.div`
  width: 350px;
  height: calc(100% - 64px);
  float: left;
  background: #242525;
  overflow-y: auto;
  overflow-x: hidden;

  @-moz-document url-prefix() {
    height: 100%;
  }

  @media screen and (max-width: 800px) {
    position: relative;
    width: 100%;
    height: auto;
    float: left;
    overflow-y: visible;
  }
`;
